import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { toast } from "sonner";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useT } from "@/lib/i18n";

const KEY = "pp_ref";

// Captures ?ref=CODE on any URL, then applies it once the (new) user is signed in.
export default function ReferralCapture() {
  const { user, refresh } = useAuth();
  const location = useLocation();
  const { t } = useT();
  const busy = useRef(false);

  useEffect(() => {
    const ref = new URLSearchParams(location.search).get("ref");
    if (ref) localStorage.setItem(KEY, ref.toUpperCase());
  }, [location.search]);

  useEffect(() => {
    const code = localStorage.getItem(KEY);
    if (!code || !user || user.referred_by || busy.current) return;
    busy.current = true;
    (async () => {
      try {
        const { data } = await api.post("/referrals/apply", { code });
        toast.success(t("ref_applied").replace("{n}", Number(data.reward).toLocaleString()).replace("{name}", data.referrer_name || "a friend"), { duration: 7000 });
        await refresh();
      } catch { /* expired / own code / already applied — drop silently */ }
      localStorage.removeItem(KEY);
      busy.current = false;
    })();
  }, [user, refresh, t]);

  return null;
}
